module.exports = __webpack_public_path__ + "static/media/style-bg2.dc617921.png";